import { useStore } from '../store'
import { ALERTS_ACTIONS } from '../store/alerts'

const useAlert = () => {
  const { dispatch } = useStore()

  const createAlert = (alert) => {
    dispatch({
      type: ALERTS_ACTIONS.CREATE_ALERT,
      alert,
    })
  }

  const createGenericErrorAlert = () => {
    dispatch({
      type: ALERTS_ACTIONS.CREATE_ALERT,
      alert: {
        message: 'Something went wrong',
        severity: 'error',
      },
    })
  }

  return { createAlert, createGenericErrorAlert }
}

export default useAlert
